class ManageFeatureController {
    constructor() {
        this.show = 'options';
    }
}
angular.module('app').component('manageFeatures', {
    templateUrl: 'Scripts/App/partials/Features/manage-features.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ManageFeatureController
});
